import { render, staticRenderFns } from "./ResendInvitations.vue?vue&type=template&id=610c7f76"
import script from "./ResendInvitations.vue?vue&type=script&lang=js"
export * from "./ResendInvitations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports